import NavBar from './components/NavBar/NavBar';
import HomePage from './pages/HomePage/HomePage'


import './style.css';

function App() {
  return (
    <div className="App">
      <>
        <HomePage />
      </>
    </div>
  );
}

export default App;
